import { handleActions } from 'redux-actions';
import types from '@/actions/simulationTypes';

const initialState = {
  enabled: false,
  data: [],
  result: [],
  prevWeekAccumulateWorkMinutes: 0
};

/* Reducer */
export default handleActions({
  [types.ENABLE_SIMULATION]: (state) => {
    return { ...state,
        enabled: true
    }
  },
  [types.DISABLE_SIMULATION]: (state) => {
    return { ...state,
        enabled: false
    }
  },
  [types.SET_SIMULATION_DATA]: (state, action) => {
    return { ...state,
      data: action.data
    }
  },
  [types.CHANGE_SIMULATION_DATA]: (state, action) => {
    return { ...state,
      data: action.data
    }
  },
  [types.SET_SIMULATION_RESULT]: (state, action) => {
    return { ...state,
      result: action.result
    }
  },
}, initialState);



// WEBPACK FOOTER //
// ./src/reducers/simulationReducer.js